export default function formateDate(date: string) {
    const dateList = date.split('-');
    return dateList.reverse().join('/');
}